import { Page } from '../../../../../components/page/page.tsx';
import s from './forms-create.module.css';
import { Sorter } from '../../../../../features/sorter/sorter.tsx';
import { SortableItem } from '../../../../../features/sorter/sortable-item.tsx';
import { Button } from '../../../../../components/button/button.tsx';
import { Card } from '../../../../../components/card/card.tsx';
import { FormCreateModal } from './form-create-modal/form-create-modal.tsx';
import { Divider } from '../../../../../components/divider/divider.tsx';
import { LangInput } from '../../../../../features/lang-input/lang-input.tsx';
import { FormCreateInput } from './form-create-modal/form-create-input-types/form-create-input.tsx';
import { FormCreateSelect } from './form-create-modal/form-create-input-types/form-create-select.tsx';
import { FormCreateDateTime } from './form-create-modal/form-create-input-types/form-create-date-time.tsx';
import { FormCreateDateTimeRange } from './form-create-modal/form-create-input-types/form-create-date-time-range.tsx';
import { FormElementTypeType } from '../../../../../store/api/forms-api.ts';
import { FormCreateSwitch } from './form-create-modal/form-create-input-types/form-create-switch.tsx';
import { FormCreateCheckbox } from './form-create-modal/form-create-input-types/form-create-checkbox.tsx';
import { FormCreateMultiSelect } from './form-create-modal/form-create-input-types/form-create-multi-select.tsx';
import { IconButton } from '../../../../../components/icon-button/icon-button.tsx';
import { AiOutlineEdit } from 'react-icons/ai';
import { MdDeleteForever } from 'react-icons/md';
import { Tooltip } from '../../../../../features/tooltip/tooltip.tsx';
import { ActionsIcon } from '../../../../../assets/svg/actions.tsx';
import { Container } from '../../../../../components/container/container.tsx';
import { useCreateForm } from './use-create-form.ts';

export const CreateForm = () => {
  const {
    createElementModal,
    form,
    getLocale,
    handleCreate,
    handleDeleteElement,
    handleSort,
    handleUpdateForm,
    id,
    language,
    t,
  } = useCreateForm();

  return (
    <Page className={s.page}>
      <h2>{t(id ? 'Изменить форму' : 'Создать форму')}</h2>
      <Card title={t('Настройка')} withLang>
        <Container label={t('Название')}>
          <LangInput
            name="name"
            onChange={(e) => handleUpdateForm({ name: e })}
            value={form?.name}
          />
        </Container>
        <Divider />
        <Sorter itemIds={form?.elements?.map((item) => item.uuid!) || []} onSort={handleSort}>
          <ul className={s.list}>
            {form?.elements?.map((item, index) => {
              const key = item.uuid!;
              const type = item.type as FormElementTypeType;
              const helperText = item.info?.helper_text;
              const helper = item.info?.helper;

              return (
                <SortableItem
                  className={s.item}
                  id={key}
                  key={key}
                  sortableArgs={{
                    id: key,
                    data: {
                      index,
                    },
                  }}
                >
                  <Container
                    label={helper === 'label' ? getLocale(helperText, language) : undefined}
                    style={{ alignItems: 'flex-start' }}
                  >
                    <div className={s.itemContent}>
                      {type === 'input' && <FormCreateInput formElement={item} />}
                      {type === 'select' && <FormCreateSelect formElement={item} />}
                      {type === 'datetime' && <FormCreateDateTime />}
                      {type === 'datetimeRange' && <FormCreateDateTimeRange />}
                      {type === 'switch' && <FormCreateSwitch formElement={item} />}
                      {type === 'checkbox' && <FormCreateCheckbox formElement={item} />}
                      {type === 'multi-select' && <FormCreateMultiSelect formElement={item} />}
                      <Tooltip
                        trigger={<ActionsIcon />}
                        optionsWrapperClassName={s.actions}
                        closeOnContentClick
                      >
                        <IconButton
                          tooltip={t('Редактировать')}
                          size="sm"
                          variant="secondary"
                          onClick={() => createElementModal.handleOpenModal({ elementId: key })}
                        >
                          <AiOutlineEdit />
                        </IconButton>
                        <IconButton
                          tooltip={t('Удалить')}
                          variant="secondary"
                          onClick={() => handleDeleteElement(key)}
                          size="sm"
                        >
                          <MdDeleteForever />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </Container>
                </SortableItem>
              );
            })}
          </ul>
        </Sorter>
        <Button onClick={() => createElementModal.handleOpenModal()}>
          {t('Добавить элемент')}
        </Button>
        <Divider />
        <div className={s.controls}>
          <Button variant="secondary" hrefBack>
            {t('Отменить')}
          </Button>
          <Button variant="primary" onClick={handleCreate}>
            {t(id ? 'Изменить форму' : 'Создать форму')}
          </Button>
        </div>
      </Card>
      {createElementModal.isOpen && (
        <FormCreateModal onClose={() => createElementModal.handleCloseModal(['elementId'])} />
      )}
    </Page>
  );
};
